import React, { createContext, useContext } from 'react';
import { useGetIsModifiable } from "../../clientState/hooks";
import { useModificationTripInfo } from "./..";
const ModificationProcessabilityContext = /*#__PURE__*/createContext(null);
export function useModificationProcessability() {
  const processability = useContext(ModificationProcessabilityContext);
  if (processability !== false && typeof processability !== 'object') {
    throw new Error('No ModificationProcessabilityProvider found');
  }
  return processability;
}
const ModificationProcessabilityProvider = ({
  children
}) => {
  const {
    bookingId,
    bookingItemId,
    email,
    loading,
    errors
  } = useModificationTripInfo();
  const {
    data,
    loading: loadingModifiable,
    errors: errorsModifiable
  } = useGetIsModifiable({
    bookingId,
    email,
    bookingItemId,
    skip: !bookingId || !email || !bookingItemId
  });
  const {
    isModifiable: {
      modifiable
    }
  } = data || {
    isModifiable: {}
  };
  return /*#__PURE__*/React.createElement(ModificationProcessabilityContext.Provider, {
    value: {
      modifiable,
      loading: loading || loadingModifiable,
      errors: errors || errorsModifiable
    }
  }, children);
};
export default ModificationProcessabilityProvider;